import { SuperModel } from './super-model.model';
import { ECurrency, EOrderFulfillmentStatus, EOrderPaymentStatus } from '@common/enums';
import { SalesOrderItem } from './order-item.model';
import { ReturnOrder } from './return-order.model';
import { IAddress, IOrderHistory, IPaymentInfo, IPriceModifications } from '@interfaces';

export class SalesOrder extends SuperModel {
  orderNumber: string;
  orderDate: string;
  paymentStatus?: EOrderPaymentStatus;
  fulfillmentStatus?: EOrderFulfillmentStatus;
  orderHistory: IOrderHistory[];
  paymentInfo: IPaymentInfo[];
  priceModifications: IPriceModifications[];
  deliveryCompany: any;
  deliveryStreet: string;
  deliveryCity: string;
  deliveryZip: string;
  deliveryProvince: string;
  deliveryCountry: string;
  pickingTipology: string;
  pickingStore: {
    name: string;
    warehouse_type: string;
  };
  customerFirstname: string;
  customerLastname: string;
  customerFullName: string;
  customerEmail: string;
  customerStreet: string;
  customerCity: string;
  customerZip: string;
  customerCompany: string;
  customerProvince: string;
  customerProvinceCode: string;
  customerCountry: string;
  customerPhone: string;
  totalPrice: number;
  salesOrderItems: SalesOrderItem[];
  currency: string;
  returns?: ReturnOrder[];

  constructor(data: Partial<SalesOrder> = {}) {
    super(data);

    if (data.salesOrderItems) {
      this.salesOrderItems = data.salesOrderItems.map(item => new SalesOrderItem(item));
    }
    if (data.returns) {
      this.returns = data.returns.map(returnOrder => new ReturnOrder(returnOrder));
    }
    if (!data.currency) {
      this.currency = ECurrency.EUR;
    }
  }

  get customerName() {
    return `${this.customerFirstname || ''} ${this.customerLastname || ''}`;
  }

  get orderCustomerName() {
    let customerFullname = `${this.customerFirstname || ''} ${this.customerLastname || ''}`;
    if (customerFullname && customerFullname.trim() === '') {
      customerFullname = `${this.customerFirstname || ''} ${this.customerLastname || ''}`;
    }
    return customerFullname;
  }

  get hasInvoiceAddress() {
    return this.customerStreet;
  }

  get invoiceAddress(): IAddress {
    return {
      name: this.customerName,
      company: this.customerCompany,
      street: this.customerStreet,
      city: this.customerCity,
      zip: this.customerZip,
      province: this.customerProvince,
      provinceCode: this.customerProvinceCode,
      country: this.customerCountry,
    };
  }

  get hasDeliveryAddress() {
    return this.deliveryStreet;
  }

  get deliveryAddress(): IAddress {
    return {
      name: this.customerName,
      company: this.deliveryCompany,
      street: this.deliveryStreet,
      city: this.deliveryCity,
      zip: this.deliveryZip,
      province: this.deliveryProvince,
      provinceCode: '',
      country: this.deliveryCountry,
    };
  }

  get serialised() {
    return {
      orderPaymentStatus: this.paymentStatus,
      fulfillmentStatus: this.fulfillmentStatus,
    };
  }

  get paymentState() {
    if (this.paymentInfo != null && this.paymentInfo.length > 0) {
      return this.paymentInfo[0].paymentStatus;
    } else {
      return 'MISSING';
    }
  }
}
